import { useState, useEffect, useRef } from 'react';
import { GoSearch } from 'react-icons/go';
import { useDebounceCallback } from 'usehooks-ts';
import { useRouter } from 'next/router';
import SearchResults from './SearchResults';
import { Input } from '@/components/ui/input';
const SearchBar: React.FC = () => {
  const inputRef = useRef<HTMLInputElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const debounced = useDebounceCallback(setSearchValue, 500);
  const router = useRouter();
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      // Check if wrapperRef contains the target and if the target's role is not "dialog"
      if (wrapperRef.current && !wrapperRef.current.contains(target) && !target.closest('[role="dialog"]')) {
        setIsFocused(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setSearchValue('');
    inputRef.current.value = '';
    setIsFocused(false);
  }, [router.asPath]);
  return <div ref={wrapperRef} className={`relative w-full h-[34px] flex items-center text-genius-cream bg-genius-blue rounded-full px-[12px] border transition-colors ${isFocused ? 'border-genius-pink' : 'border-transparent'}`} data-sentry-component="SearchBar" data-sentry-source-file="SearchBar.tsx">
      <GoSearch className='w-[18px] h-[18px]' data-sentry-element="GoSearch" data-sentry-source-file="SearchBar.tsx" />
      <Input ref={inputRef} type='text' onChange={e => debounced(e.target.value)} placeholder='Search' className={`bg-transparent border-none rounded-md`} onFocus={() => setIsFocused(true)} data-sentry-element="Input" data-sentry-source-file="SearchBar.tsx" />

      {isFocused && <SearchResults input={searchValue} />}
    </div>;
};
export default SearchBar;